var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-integrarion-container--wrapper"
  }, [_c('h4', {
    staticClass: "form-integrarion-text"
  }, [_vm._v("Choose an option")]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.mode,
      callback: function ($$v) {
        _vm.mode = $$v;
      },
      expression: "mode"
    }
  }, [_c('v-radio', {
    staticClass: "mb-3",
    attrs: {
      "label": ("Create a new " + (_vm.type)),
      "value": "create"
    }
  }), _c('v-radio', {
    attrs: {
      "label": ("Use an existing " + (_vm.type)),
      "value": "use"
    }
  })], 1), _c(_vm.currentComponent, {
    tag: "component",
    attrs: {
      "type": _vm.type,
      "integration": _vm.integration,
      "items": _vm.items
    },
    on: {
      "save-info": _vm.saveInfo
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }